var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    [
      _c(
        "v-container",
        { staticClass: "pa-0", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-12" },
            [
              _c("v-col", { attrs: { cols: "1", sm: "1", md: "1" } }),
              _c(
                "v-col",
                [
                  _c(
                    "v-row",
                    { attrs: { align: "center", "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "text-center",
                          attrs: { cols: "2", md: "2" }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "black--text",
                              attrs: {
                                href: "https://aexi.nl/",
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "ml-0 login_img",
                                attrs: {
                                  src:
                                    "https://aexi.nl/wp-content/uploads/2021/11/aexi-logo.svg",
                                  alt: "AEXI company logo"
                                }
                              })
                            ]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "black--text",
                              attrs: {
                                href:
                                  "https://www.time.rwth-aachen.de/cms/TIME/Die-Research-Area/~bpyaxq/Oekonomie-von-Innovation-Handel-und-Entwicklung/lidx/1/",
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "ml-0 login_img",
                                attrs: {
                                  alt: "Time RWTH-Aachen logo",
                                  onload: "triggerResize(true);",
                                  src:
                                    "https://www.time.rwth-aachen.de/global/show_picture.asp?id=aaaaaaaaaakewdr"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _c("v-col", { attrs: { cols: "9", md: "9" } }),
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "align-self-start pa-0 aexi_blue_text mt-6",
                          attrs: { cols: "12", lg: "4", md: "5" }
                        },
                        [
                          _c("p", [_vm._v("Grow your exports,")]),
                          _c("span", { staticClass: "aexi_green_text" }, [
                            _vm._v(" sustainably ")
                          ]),
                          _c("span", { staticClass: "ml-6 right-border" }),
                          _vm.is_compatible_browser()
                            ? _c("div", { staticClass: "login" }, [
                                _c("div", { staticClass: "login-screen" }, [
                                  _c("form", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "login-form",
                                        on: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.start_login_process.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [
                                        !_vm.login_started
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "control-group"
                                                  },
                                                  [
                                                    _c("label", {
                                                      attrs: { for: "username" }
                                                    }),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.username,
                                                          expression: "username"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "login-field poppins",
                                                      attrs: {
                                                        id: "username",
                                                        placeholder: "username",
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value: _vm.username
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.username =
                                                            $event.target.value
                                                        }
                                                      }
                                                    }),
                                                    _c("label", {
                                                      staticClass:
                                                        "login-field-icon fui-user",
                                                      attrs: {
                                                        for: "login-name"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "control-group"
                                                  },
                                                  [
                                                    _c("label", {
                                                      attrs: { for: "password" }
                                                    }),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.password,
                                                          expression: "password"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "login-field",
                                                      attrs: {
                                                        id: "password",
                                                        autocomplete: "on",
                                                        placeholder: "password",
                                                        type: "password"
                                                      },
                                                      domProps: {
                                                        value: _vm.password
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.password =
                                                            $event.target.value
                                                        }
                                                      }
                                                    }),
                                                    _c("label", {
                                                      staticClass:
                                                        "login-field-icon fui-lock",
                                                      attrs: {
                                                        for: "login-pass"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: {
                                                      bottom: "",
                                                      disabled:
                                                        _vm.policy_accepted ||
                                                        (!_vm.policy_agree_false_text &&
                                                          !_vm.policy_agree_true_text)
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var on = ref.on
                                                            var attrs =
                                                              ref.attrs
                                                            return [
                                                              _c(
                                                                "div",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {},
                                                                    "div",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      staticClass:
                                                                        "btn btn-large btn-block aexi_green_background poppins",
                                                                      attrs: {
                                                                        id:
                                                                          "login",
                                                                        color:
                                                                          "#9bbc32",
                                                                        disabled:
                                                                          !_vm.policy_accepted &&
                                                                          (!!_vm.policy_agree_false_text ||
                                                                            !!_vm.policy_agree_true_text)
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          _vm.start_login_process_local
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "LOG IN "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      3377196847
                                                    )
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "Please accept the privacy policy below"
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _c("v-checkbox", {
                                                  staticClass:
                                                    "shrink mt-1 mb-0 checksize ml-2 text-right poppins",
                                                  attrs: {
                                                    label:
                                                      "Clear Cache on Login"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.clear_casch_selected,
                                                    callback: function($$v) {
                                                      _vm.clear_casch_selected = $$v
                                                    },
                                                    expression:
                                                      "clear_casch_selected"
                                                  }
                                                }),
                                                _vm.policy_agree_false_text ||
                                                _vm.policy_agree_true_text
                                                  ? _c("v-checkbox", {
                                                      staticClass:
                                                        "shrink mt-0 mb-0 checksize ml-2 text-right poppins",
                                                      attrs: {
                                                        label:
                                                          _vm.policyCheckboxLabel
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.policy_accepted,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.policy_accepted = $$v
                                                        },
                                                        expression:
                                                          "policy_accepted"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm.policyHtmlContent
                                                  ? _c("div", {
                                                      staticClass:
                                                        "ml-2 mt-0 poppins policy-content",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.policyHtmlContent
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "trade-blue-text"
                                              },
                                              [
                                                _c("v-progress-linear", {
                                                  attrs: {
                                                    indeterminate: "",
                                                    color: "rgba(108, 176, 61)"
                                                  }
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mt-12 mb-12  aexi_blue_text text-h4"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Logging in please be patient.. "
                                                    ),
                                                    _c("v-progress-circular", {
                                                      attrs: {
                                                        width: 3,
                                                        color:
                                                          "rgba(108, 176, 61)",
                                                        indeterminate: ""
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c("v-progress-linear", {
                                                  attrs: {
                                                    indeterminate: "",
                                                    color: "rgba(108, 176, 61)"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                        _vm.login_error && _vm.backend_alive
                                          ? [
                                              _c(
                                                "v-snackbar",
                                                {
                                                  attrs: {
                                                    timeout: 4000,
                                                    centered: "",
                                                    color: "red lighten-1",
                                                    shaped: ""
                                                  },
                                                  model: {
                                                    value: _vm.login_error,
                                                    callback: function($$v) {
                                                      _vm.login_error = $$v
                                                    },
                                                    expression: "login_error"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticClass:
                                                        "text-center pa-2 black--text lighten-2"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Incorrect username or password. "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ])
                                ])
                              ])
                            : _c(
                                "div",
                                { staticClass: "mr-12 mt-12" },
                                [_c("browser_compat_box")],
                                1
                              )
                        ]
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", lg: "5", md: "7" } },
                        [
                          _vm.article !== "error"
                            ? [
                                _vm.article.Title
                                  ? [
                                      _vm.article.Title
                                        ? _c(
                                            "h1",
                                            {
                                              staticClass:
                                                "aexi_green_text_only"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.article.Title) +
                                                  " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "aexi_green_text_only font-italic"
                                        },
                                        [_vm._v(_vm._s(_vm.article.Headline))]
                                      ),
                                      _c(
                                        "p",
                                        { staticClass: "aexi_blue_text_only" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(_vm.article.p1) + " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        { staticClass: "aexi_dark_text_only" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(_vm.article.p2) + " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        { staticClass: "aexi_dark_text_only" },
                                        [_vm._v(_vm._s(_vm.article.p3))]
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "black--text",
                                          attrs: {
                                            href: _vm.article.readMoreLink,
                                            target: "_blank",
                                            rel: "noopener noreferrer"
                                          }
                                        },
                                        [_vm._v("Read more")]
                                      )
                                    ]
                                  : _vm._e()
                              ]
                            : _vm._e()
                        ],
                        2
                      ),
                      _c(
                        "v-col",
                        { attrs: { align: "center" } },
                        [
                          _c("v-img", {
                            staticClass: "ml-4 ml-sm-12",
                            attrs: {
                              src: require("../../assets/img/half-X01-1.png"),
                              width: "200"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "mt-6",
              attrs: { "no-gutters": "", align: "center", justify: "start" }
            },
            [
              _c("v-col", { attrs: { cols: "1", sm: "1", md: "1" } }),
              _c("v-col", [
                _c("div", {
                  staticClass: "login-page-content aexi_dark_text_only",
                  domProps: { innerHTML: _vm._s(_vm.loginPageContent) }
                })
              ]),
              _c("v-col", { attrs: { cols: "1", sm: "1", md: "1" } })
            ],
            1
          ),
          _c("applcation_selector", {
            attrs: {
              select_application_open:
                _vm.$store.state.app.application_selector_open
            },
            on: {
              "update:select_application_open": function($event) {
                return _vm.$set(
                  _vm.$store.state.app,
                  "application_selector_open",
                  $event
                )
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }